import React from 'react';
import { useLazyQuery, useMutation, gql } from '@apollo/client';
import QuarantineUnserialized from './QuarantineUnserialized';

const STOCK_ZONE_INVENTORY_BALANCES = gql`
  query paginatedZoneInventoryBalancesByZone($zoneId: ID!, $companyId: ID!) {
    unserializedPaginatedZoneInventoryBalancesByZone(
      zoneId: $zoneId
      companyId: $companyId
      paginationAttributes: { limit: 200, skip: 0 }
    ) {
      zoneInventoryBalances {
        id
        stocked
        lot
        expiration
        zone {
          id
          name
        }
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
      pagination {
        totalRecords
      }
    }
  }
`;

const QUARANTINE_UNSERIALIZED_ITEMS = gql`
  mutation quarantineUnserializedItems(
    $companyId: ID!
    $quarantineZoneId: ID!
    $quarantineUnserializedItemsAttributes: [QuarantineUnserializedItemsAttributes!]!
  ) {
    quarantineUnserializedItems(
      companyId: $companyId
      quarantineZoneId: $quarantineZoneId
      quarantineUnserializedItemsAttributes: $quarantineUnserializedItemsAttributes
    )
  }
`;


const QuarantineUnserializedData = (props) => {
  const [quarantineUnserializedItems] = useMutation(QUARANTINE_UNSERIALIZED_ITEMS);
  const [getStockZoneInventoryBalances, { data: stockZoneInventoryBalancesData }] =
    useLazyQuery(STOCK_ZONE_INVENTORY_BALANCES, { fetchPolicy: 'network-only' });

  const {
    unserializedPaginatedZoneInventoryBalancesByZone: {
      zoneInventoryBalances: stockZoneInventoryBalances = []
    } = {}
  } = stockZoneInventoryBalancesData || {};

  return (
    <QuarantineUnserialized
      quarantineUnserializedItems={quarantineUnserializedItems}
      getStockZoneInventoryBalances={getStockZoneInventoryBalances}
      stockZoneInventoryBalances={stockZoneInventoryBalances}
      {...props}
    />
  );
};

export default QuarantineUnserializedData;
